export default __webpack_public_path__ + "static/tub_w.e6503418a5d1d5ba01614c40c0f641e0.svg";